var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_758_1673)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00051 0.868652L15.1319 14L14.0005 15.1314L0.869141 2.00002L2.00051 0.868652Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05338 6.11862C7.35602 6.42148 7.35585 6.91235 7.05299 7.215C6.87516 7.3927 6.77521 7.63376 6.77512 7.88515C6.77503 8.13655 6.87481 8.37768 7.05251 8.55551C7.23021 8.73333 7.47128 8.83329 7.72267 8.83337C7.97407 8.83346 8.2152 8.73368 8.39303 8.55598C8.69589 8.25333 9.18675 8.25351 9.4894 8.55637C9.79205 8.85923 9.79188 9.3501 9.48902 9.65275C9.02031 10.1211 8.38474 10.3841 7.72212 10.3839C7.05951 10.3837 6.42412 10.1202 5.95575 9.6515C5.48737 9.18279 5.22438 8.54722 5.22461 7.88461C5.22484 7.22199 5.48829 6.58661 5.957 6.11823C6.25986 5.81558 6.75073 5.81576 7.05338 6.11862Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83064 4.19324L13.371 8.56665C13.4947 8.38565 13.6169 8.19673 13.7375 7.99981C12.3088 5.66624 10.6689 4.46459 8.83064 4.19324ZM8.00162 2.53324C7.57994 2.53183 7.15946 2.56794 6.74511 2.64088L5.19581 2.9136L13.5476 10.9583L14.0958 10.2754C14.5438 9.71731 14.9652 9.09014 15.3614 8.39693L15.5883 7.99997L15.3615 7.60298C13.497 4.34035 11.0516 2.5338 8.00162 2.53324ZM5.44469 4.87956L4.78263 5.32864C3.83695 5.9701 3.04169 6.7443 2.26351 8.00098C3.90385 10.6797 5.82258 11.8666 8.00022 11.8666C9.14595 11.8666 9.93947 11.6419 10.8862 11.0033L11.5495 10.556L12.4441 11.8825L11.7809 12.3298C10.553 13.158 9.44382 13.4666 8.00022 13.4666C4.94954 13.4666 2.50371 11.66 0.638967 8.39684L0.412109 7.99986L0.639011 7.6029C1.60987 5.90443 2.63367 4.85293 3.88447 4.00451L4.54654 3.55543L5.44469 4.87956Z",
    fill: "#979797"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_758_1673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.544292128a87b5e19544d89185308547.svg";
export { ForwardRef as ReactComponent };